
import { City } from '@/data/cities';
import { CityLanguage } from '@/context/languages/languageData';
import { countryLanguageMap } from './countryLanguageMap';

interface CityLanguageMapping {
  citySlug: string;
  primaryLanguage: CityLanguage;
  countryCode: string;
}

export const detectCityLanguage = (city: City): CityLanguage => {
  const countryCode = city.countryCode?.toUpperCase();
  if (!countryCode) return 'en';
  
  return countryLanguageMap[countryCode] || 'en';
};

export const getCityLanguageMapping = (city: City): CityLanguageMapping => {
  const primaryLanguage = detectCityLanguage(city);
  
  return {
    citySlug: city.slug,
    primaryLanguage,
    countryCode: city.countryCode || 'US'
  };
};

export const shouldShowLanguageFlag = (city: City): boolean => {
  const primaryLanguage = detectCityLanguage(city);
  return primaryLanguage !== 'en'; // Solo mostrar bandera si no es inglés
};
